import "bootstrap/dist/css/bootstrap.min.css";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { PagesHelper } from "../common/PagesHelper";
import AutocompleteSingle from "../components/library/AutocompleteSingle";
import { MenuItem, PageName,PageState,UserInfo,UserListResponseDto,UserPermissions } from "../utils/types";
import { ResponseStatus } from "../utils/types";
import StateHelper from "../utils/StateHelper";
import { Col, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { camelCaseToKebabCase, camelCaseToTitleCase } from "../utils/misc";
import './CurrentUserBar.css';
import MenuIcon from '../assets/icons/menu.svg';
import { setDocumentTitle } from "../utils/documentTitle";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface CurrentUserBarProps {
  currentUser: UserInfo;
  activeLink: string;
  setActiveLink: (page: string) => void;
  onChange: (selected: any) => void;
  viewAsUserListDto: UserListResponseDto;
  partnerManagementDashboardMenu: Record<string, Record<string, MenuItem>>;
  envBgColor: string;
}

export default function CurrentUserBar(props : CurrentUserBarProps) : any {
  const currentUser =  props.currentUser;

  function onLogout() {
    let currentLocation = window.location.href;
    window.location.href = process.env.REACT_APP_LOGOUT_URL.replace("{REDIRECT_URL}", encodeURIComponent(currentLocation));
  }

  function onPageChange(e: any, page:string) {
    if (!e.ctrlKey && !e.metaKey) {
      props.setActiveLink(page);
      setDocumentTitle(page, currentUser);
      const pageState : PageState = StateHelper.getPageState();
      pageState.page = page;
    }
  }

  const adminIcon = <FontAwesomeIcon icon={faLock} fixedWidth></FontAwesomeIcon>;

  if (currentUser == null) {
    return (<Form inline></Form>);
  } else {

    let viewAsObj = null;
    const pageState : PageState = StateHelper.getPageState();
    const viewAsUserId = pageState.viewAs;

    if (props.viewAsUserListDto) {
      if (props.viewAsUserListDto.status === ResponseStatus.ERROR) {
        viewAsObj = <Form.Control type="text" className="text-center" placeholder="Unable to load Users" size="sm" style={{borderColor : 'red', backgroundColor: 'gainsboro'}} readOnly />;
      }
      else {
        const userList = props.viewAsUserListDto.userListResponse ? props.viewAsUserListDto.userListResponse : []; 
        const labelKeyFunction = (user: any, obj : any, index : number) => {
          return user.name === user.email ? user.name : user.name + " (" + user.email + ")";
        }
        let selectedUsers : any[] =  [];
        if ( viewAsUserId != null && userList.length > 0 ){
          selectedUsers = userList.filter((item : any) => item.userId === viewAsUserId);
        }

        viewAsObj = <AutocompleteSingle
                      placeholder="View as User" id="viewAsUserCmb1"
                      labelKey={labelKeyFunction}
                      options={userList}
                      onChange={props.onChange}
                      selected={selectedUsers}
                      style={{ fontSize: 11, width: "250px" }}
                    />;
      }
    }

    const overallUrl = PagesHelper.getPageUrl(PageName.overall, pageState);
    const productsUrl = PagesHelper.getPageUrl(PageName.products, pageState);

    const canViewPerformancePage : boolean = currentUser.permissions && currentUser.permissions.includes(UserPermissions.appptapDataPerformance);
    const canViewCampaignLookupPage : boolean = currentUser.permissions && currentUser.permissions.includes(UserPermissions.appptapDashboardsCampaignLookup);
    const canViewCampaignLinksPage : boolean = currentUser.permissions && (currentUser.permissions.includes(UserPermissions.appptapDashboardsCampaignLinks) || currentUser.permissions.includes(UserPermissions.appptapDashboardsAffiliateDashboard));

    const performanceReportsUrl = canViewPerformancePage ? PagesHelper.getPageUrl(PageName.performanceReports, pageState) : null;
    const campaignLinksUrl = canViewCampaignLinksPage ? PagesHelper.getPageUrl(PageName.campaignLinks, pageState) : null;
    const campaignLookupUrl = canViewCampaignLookupPage ? PagesHelper.getPageUrl(PageName.campaignLookup, pageState) : null;

    // deep copy props.partnerManagementDashboardMenu
    let combinedMenu:Record<string, Record<string, MenuItem>> = JSON.parse(JSON.stringify(props.partnerManagementDashboardMenu));
    combinedMenu = {};
    combinedMenu['Reporting'] = {};
    combinedMenu['Reporting']['Overall'] = {link: overallUrl, page: PageName.overall};
    combinedMenu['Reporting']['Products'] = {link: productsUrl, page: PageName.products};
    if ( canViewPerformancePage ) {
      combinedMenu['Reporting']['Performance Reports'] = {link: performanceReportsUrl, page: PageName.performanceReports};
    }

    if ( canViewCampaignLinksPage || canViewCampaignLookupPage ) {
      combinedMenu['Campaigns'] = {}
      if ( canViewCampaignLinksPage ) {
        const campaignLinksTitle = currentUser.permissions.includes(UserPermissions.appptapDashboardsAffiliateDashboard) && !currentUser.permissions.includes(UserPermissions.appptapDashboardsCampaignLinks) ? "Affiliate Campaigns" : "Campaign Links";
        combinedMenu['Campaigns'][campaignLinksTitle] = {link: campaignLinksUrl, page: PageName.campaignLinks};
      }
      if ( canViewCampaignLookupPage ) {
        combinedMenu['Campaigns']['Campaign Lookup'] = {link: campaignLookupUrl, page: PageName.campaignLookup};
      }
    }

    // allow the dashboard to add / override with its own menu items
    if ( props.partnerManagementDashboardMenu ) {
      Object.keys(props.partnerManagementDashboardMenu).forEach((dropdownMenu) => {
        Object.keys(props.partnerManagementDashboardMenu[dropdownMenu]).forEach((title) => {
          // copy the menu item for some modifications below
          const menuItem = JSON.parse(JSON.stringify(props.partnerManagementDashboardMenu[dropdownMenu][title]));

          // if the menu item represents one of the built-in pages, then update the link to reference the built-in page
          if (menuItem.id) {
            switch (menuItem.id) {
              case "reporting-dashboard-" + camelCaseToKebabCase(PageName.overall):
                menuItem.link = overallUrl;
                menuItem.page = PageName.overall;
                break;
              case "reporting-dashboard-" + camelCaseToKebabCase(PageName.products):
                menuItem.link = productsUrl;
                menuItem.page = PageName.products;
                break;
              case "reporting-dashboard-" + camelCaseToKebabCase(PageName.performanceReports):
                menuItem.link = performanceReportsUrl;
                menuItem.page = PageName.performanceReports;
                break;
                case "reporting-dashboard-" + camelCaseToKebabCase(PageName.campaignLinks):
                  menuItem.link = campaignLinksUrl;
                  menuItem.page = PageName.campaignLinks;
                  break;
                case "reporting-dashboard-" + camelCaseToKebabCase(PageName.campaignLookup):
                  menuItem.link = campaignLookupUrl;
                  menuItem.page = PageName.campaignLookup;
                  break;
            }
          }

          if ( !combinedMenu[dropdownMenu] ) {
            combinedMenu[dropdownMenu] = {};
          }
          combinedMenu[dropdownMenu][title] = menuItem;
        });
      });
    }

    return (
      <>
        <Navbar className={"reporting-dashboard-navbar " + props.envBgColor} style={{ justifyContent: "space-", padding: 0, color: "white" }}>
          <Col xl={4} style={{ display: "flex", padding: 0 }}>
            <Nav.Link data-toggle="collapse" style={{ padding: "12px 24px", color: "white", backgroundColor: "#272C30", fontSize: "1rem" }} data-target="#navbar-container" aria-controls="navbarSupportedContent1">
              <img src={MenuIcon} style={{ width: "16px", height: "16px", verticalAlign: "text-bottom", marginRight: "5px" }} alt="menu" />
              {process.env.REACT_APP_NAME}
            </Nav.Link>
          </Col>
          <Col xl={4} style={{ display: "flex", justifyContent: "center", fontSize: "1rem" }}>
            {
              process.env.REACT_APP_BRANCH && <span>{process.env.REACT_APP_BRANCH}&nbsp;-&nbsp;</span>
            }
            <span>{camelCaseToTitleCase(props.activeLink)}</span>
          </Col>
          <Col xl={4} style={{ display: "flex", justifyContent: "right", padding: "0 9px" }}>
            <Nav.Link onClick={onLogout} style={{ display: "flex", alignItems: "center" }}>
              Sign out
              <img src={currentUser.picture} title={currentUser ? currentUser.email : ""} alt={currentUser ? currentUser.email : ""} style={currentUser.picture ? { maxHeight: "25px", maxWidth: "25px", paddingLeft: "5px" } : { paddingLeft: "5px" }} />
            </Nav.Link>
          </Col>
        </Navbar>

        <div id="navbar-container" className="reporting-dashboard-navbar bg-dark collapse show">
          <Navbar id="navbar" style={{ justifyContent: "space-between", backgroundColor: "#272C30" }}>
            <div className="d-flex align-items-center">
            {(
                Object.keys(combinedMenu).map((dropdownMenu) => {
                  return (
                    <NavDropdown key={dropdownMenu} title={dropdownMenu} id={dropdownMenu}>
                      {
                        Object.keys(combinedMenu[dropdownMenu]).map((title:string) => {                              
                          const menuItem = combinedMenu[dropdownMenu][title];
                          if ( menuItem.page != null ) {
                            return <NavDropdown.Item to={menuItem.link} as={Link} key={title} disabled={menuItem.page === props.activeLink} onClick={(e) => onPageChange(e, menuItem.page)}>{title} {menuItem.admin ? adminIcon :""}</NavDropdown.Item>
                          } else {                                  
                            return <a className="dropdown-item" href={menuItem.link} key={title}>{title} {menuItem.admin ? adminIcon :""}</a>
                          }
                        })
                      }
                    </NavDropdown>
                  );
                })                  
            )}
            {pageState.viewAs && <Nav.Link disabled={true} style={{fontStyle: "italic"}}>&laquo;PMD menu unavailable with view-as&raquo;</Nav.Link> }
            
            {/* null meaning an error fetching the menu - empty is a success, with no menu items */}
            {!pageState.viewAs && props.partnerManagementDashboardMenu == null && <Nav.Link disabled={true} style={{fontStyle: "italic"}}>&laquo;unable to load additional menu items&raquo;</Nav.Link> }
            </div>
            <Form className="d-flex align-items-center">
              {viewAsObj}
            </Form>
          </Navbar>
        </div>
      </>
    );
  }
}